<template>
  <div class="total-orders bg-white px-4 pt-4 pb-4">
    <h2 class="text-gray-500 text-sm">Total orders of the year</h2>
    <GChart
      type="ColumnChart"
      :data="chartData"
      :options="chartOptions"
    />
    <div class="mt-4">
      <p class="text-gray-400 leading-none">Total Orders</p>
      <span class="text-3xl">{{numberFormat(total, '0,0')}}</span>
      <span class="float-right"><i class="el-icon-caret-bottom text-lg text-red-500"></i></span>
    </div>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
  name: 'total_orders',
  components: {
    GChart,
  },
  data() {
    return {
      chartOptions: {
        hAxis: { textPosition: 'none' },
        chartArea: { left: '0%', width: '100%', height: '100%' },
        vAxis: {
          baselineColor: 'none',
          textPosition: 'none',
          gridlines: {
            color: 'none',
          },
        },
        colors: ['#F1F347'],
        bar: { groupWidth: '20%' },
      },
    };
  },
  computed: {
    chartData() {
      return this.$store.getters['Dashboard/allOrders'];
    },

    total() {
      return this.$store.getters['Dashboard/totalOrders'];
    },
  },

  async mounted() {
    await this.$store.dispatch('Dashboard/fetchAllOrders');
  },
};
</script>

<style scoped>
.total-orders {
  flex: 0 1 48%
}
</style>
